import classNames from 'classnames';
import { Button } from 'odc-shared/components';
import React from 'react';

import website from '@src/constants/website';

import { MonetizationCardSvg } from './MonetizationCardSvg';

import './index.scss';

type MonetizationCardProps = {
  animationEnabled?: boolean;
  skipAnimation?: boolean;
};
const MonetizationCard: React.FC<MonetizationCardProps> = ({ animationEnabled, skipAnimation }) => {
  return (
    <div
      className={classNames('odc-platform-card odc-monetization-card', { 'animation-enabled': animationEnabled }, { 'skip-animation': skipAnimation })}
      onClick={() => { window.location.href = website.monetization; }}
    >
      <div className="odc-platform-card-header">
        <div className="header-content">
          <div className="title">Monetization</div>
          <div className="desc">Client-centric monetization</div>
        </div>
        <div className="header-operate">
          <Button type="primary" >
            Get Now
          </Button>
        </div>
      </div>
      <div className="odc-platform-card-body">
        <MonetizationCardSvg className="monetization-card-svg" />
      </div>
    </div>
  );
};

export default MonetizationCard;